import React, { createElement } from 'react';
import { FelaComponent } from '../../../Theme/utils/index';
import { WithDmId } from '../../../utils/BaseProps';

type ElementProps = WithDmId & {
  /**
   * String, mit dem definiert werden kann, welches Element gerendert wird.
   */
  as?: string;
  /**
   * Objekt (oder String), das den Inhalt der Komponente bestimmt.
   */
  children?: React.ReactNode;
  /**
   * String, mit dem vordefinierte classNames an das Element übergeben werden können
   * (alternativ oder als Ergänzung zum style Attribut).
   */
  customClasses?: string;
  /**
   * Objekt, mit dem das Styling des Elements definiert werden kann.
   */
  style?: object;
  /**
   * Attribut, das der ref Property des Elements zugewiesen wird.
   */
  reference?: string | React.Ref<any>;
  [otherProp: string]: any;
};

export default function Element({
  style = {},
  children,
  as = 'div',
  dmId = 'dm-element',
  reference,
  customClasses,
  ...otherProps
}: ElementProps) {
  return (
    <FelaComponent customClass={customClasses} style={style}>
      {({ className }: { className: string }) =>
        createElement(
          as,
          {
            className,
            ref: reference,
            'data-dmid': dmId,
            'data-designsystem': true,
            ...otherProps,
          },
          children,
        )
      }
    </FelaComponent>
  );
}
